(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Mobile nav
  const toggle = qs('[data-nav-toggle]');
  const nav = qs('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Cart drawer
  const drawer = qs('[data-cart-drawer]');
  const openers = qsa('[data-cart-open]');
  const closers = qsa('[data-cart-close]');
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  openers.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
  closers.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); closeCart(); }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  // Reveal on scroll
  const reveals = qsa('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  // Language selector → localization form
  const lang = qs('[data-lang-select]');
  if (lang) {
    lang.addEventListener('change', () => {
      const form = qs('#localization_form');
      if (form) form.submit();
    });
  }
})();
